import "./rebilly.css";
import styled from "@emotion/styled";

export const RebillyCardResponsiveHandler = styled.div`
  display: grid;
  grid-gap: 1rem;
  grid-template-columns: 1fr 1fr;
  margin-bottom: 16px;

  div:first-of-type {
    grid-row: 1 / 2;
    grid-column: 1 / span 2;
  }

  .multi-field-error-message {
    display: none;
  }

  .rebilly-framepay {
    box-shadow: initial;
    background: inherit;
    color: inherit;
    border-radius: 0;
    border: none;
  }

  .rebilly-mount-point {
    align-items: center;
  }

  @media (min-width: 48em) {
    grid-template-columns: 1fr 100px 70px;
    grid-column-gap: 0.5rem;
    grid-row-gap: 0;
    align-items: flex-end;

    .chakra-form__label {
      display: none;
    }

    div:first-of-type {
      grid-row: initial;
      grid-column: initial;

      .chakra-form__label {
        display: block;
      }
    }

    .multi-field-error-message {
      display: block;
    }

    .single-field-error-message {
      display: none;
    }

    .rebilly-mount-point {
      flex: 1;
    }

    #rebilly-field-cardNumber {
      flex-basis: 50%;
    }
  }
`;
